import React, { Fragment, useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { IconButton } from "@mui/material";
import { CloseRounded, AddRounded, RemoveRounded } from "@mui/icons-material";
import { Typography, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ImageWrapper from "./ImageWrapper";

const useStyles = makeStyles()((theme) => ({
  iconButton: {
    color: theme.palette.text.primary,
  },
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

export const PID_IMAGE_ID = "pid-image-full-screen";

function PIDMarkupFullScreen({ pid_url, annotations, onClose }) {
  const [scale, setScale] = useState(1);
  const transformComponentRef = useRef(null);
  const { classes } = useStyles();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleZoomIn = () => {
    if (transformComponentRef.current) {
      transformComponentRef.current.zoomIn();
    }
  };

  const handleZoomOut = () => {
    if (transformComponentRef.current) {
      transformComponentRef.current.zoomOut();
    }
  };
  return (
    <Fragment>
      <Dialog fullScreen open={true} onClose={onClose}>
        <DialogTitle
          component={Box}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          //   sx={{
          //     boxShadow:
          //       "0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
          //           }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton onClick={onClose} className={classes.iconButton}>
              <CloseRounded />
            </IconButton>
            <Typography variant="h6">PID Markup</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Box display="flex" alignItems="center" gap={1} mr={2}>
              <Typography variant="body2">{scale.toFixed(1)}x</Typography>
              <IconButton
                onClick={handleZoomIn}
                size="small"
                disabled={scale >= 16}
                className={classes.iconButton}>
                <AddRounded />
              </IconButton>
              <IconButton
                onClick={handleZoomOut}
                size="small"
                disabled={scale <= 1}
                className={classes.iconButton}>
                <RemoveRounded fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <TransformWrapper
            initialScale={scale}
            minScale={1}
            maxScale={16}
            centerOnInit={true}
            onTransformed={(_, state) => {
              setScale(state.scale);
            }}
            ref={transformComponentRef}>
            <TransformComponent
              wrapperStyle={{
                width: "100%",
                height: "100%",
                margin: "auto",
              }}
              contentStyle={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <ImageWrapper annotations={annotations} scale={scale} PID_IMAGE_ID={PID_IMAGE_ID}>
                <img
                  id={PID_IMAGE_ID}
                  src={pid_url}
                  alt="PID Diagram"
                  style={{
                    maxWidth: "100vw",
                    maxHeight: "100vh",
                    objectFit: "contain",
                  }}
                  //   crossOrigin="anonymous"
                  onLoad={() => {
                    setIsImageLoaded(true);
                  }}
                />
              </ImageWrapper>
            </TransformComponent>
          </TransformWrapper>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}

export default PIDMarkupFullScreen;
